export default "/images/slickslide-5.jpg?06c7a0b7fac72a631411c8c207afa252";